import React, { useEffect, useState } from 'react'
import { doctors } from '../../Assets/dummyDoc'
import { diagonistics } from '../../Assets/dummyDiagons'
import Header from '../Core/Header'
import Cookies from "js-cookie";
import { actionRequestDoctor, getAlldoctors, getMappedRequestFromdoctors } from '../../service/operations/api_methods'
import { toast } from 'sonner';

const Request = () => {
   const[list1,setList1]=useState([])
    const[list2,setList2]=useState(diagonistics)
  const token = Cookies.get("token")
  const[doctors,setDoctors]=useState([])

    const handlegetRequestFromDoctors=async()=>{
        try {
            const res= await getMappedRequestFromdoctors(token)
            console.log(res);
            if(res.status===200){
                setList1(res.data.data)
                handlegetAllDoctors(res.data.data)
            }
            
        } catch (error) {
            console.log(error);
            
        }
    }

     const handlegetAllDoctors=async(list)=>{
                 try {
                     const res= await getAlldoctors(token)
                     console.log(res);
                     if(res.status===200){
                        // setDoctors(res.data.data)
                       //  const selectedDoctorIds = new Set(list.map(item => item.doctor_user_id))
                      //  const filteredList = res.data.data.filter(user => selectedDoctorIds.has(user.user_id))
                        
                        const filteredList = res.data.data.filter(item1 => list.some(item2 => String(item2.doctor_user_id) === String(item1.user_id)));
                        setDoctors(filteredList)
                        console.log(filteredList);
                        
                     }
                     
                 } catch (error) {
                     console.log(error);
                     
                 }
             }

    useEffect(() => {
        handlegetRequestFromDoctors()
       
      
    }, [])

    const handleApproveRequest=async(id)=>{
        try {
            const request=list1.find(i=>i.doctor_user_id===id)
            console.log(request);
            let data={
                action:"APPROVE"
            }
            let ind=request.id
            const res= await actionRequestDoctor(ind,data,token)
            console.log(res);
            if(res.status===200){
                toast.success(res.data.message)
            }
            
           
        } catch (error) {
            console.log(error);
            toast.error("Error!!View console")
        }
    }
     const handleRejectRequest=async(id)=>{
        try {
            const request=list1.find(i=>i.doctor_user_id===id)
            console.log(request);
            let data={
                action:"REJECT"
            }
            let ind=request.id
            const res= await actionRequestDoctor(ind,data,token)
            console.log(res);
            if(res.status===200){
                toast.success(res.data.message)
            }
            
           
        } catch (error) {
            console.log(error);
            toast.error("Error!!View console")
        }
    }
    
  return (
    <div style={{height:"100vh",width:"100%"}}>
      <Header/>
      <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px"}}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-around",padding:"6px"}}>
            <p style={{color:"white"}}>Request of Doctors</p>
            <p style={{color:"white"}}>Request of Diagnostic Center</p>
            </div>
            <div style={{display:"flex",width:'100%'}}>
            <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"50%",overflowY:"auto",overflowX:"hidden",scrollbarWidth: "none", msOverflowStyle: "none",}}>
            {
            doctors.map((item)=>(
                <div style={{width:"20vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative",overflowX:"hidden"
                }}><p style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",left:"30px"
                    }}
                    onClick={()=>handleApproveRequest(item.user_id)}>
                        Accept</p>
                        <p style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",right:"30px"
                    }}
                    onClick={()=>handleRejectRequest(item.user_id)}>
                        Reject</p>
                    <img src='/Assets/about-2.jpg' style={{height:"40%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%",}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item?.user?.first_name}  {item?.user?.last_name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Dob:{item?.user?.dob}</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>{item?.specialist_type}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"600",color:"#a3343aff"}}>License:{item?.license_number}</span>
                            </p>
                            <p>
                            <span style={{fontSize:'16px',fontWeight:"600",color:"#5456d6ff"}}>{item?.user?.address}</span></p>
                           <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"600",color:"#a3343aff"}}>{item?.user?.email}</span></p><p>
                            <span style={{fontSize:'16px',fontWeight:"600",color:"#5456d6ff"}}>{item?.user?.primary_number}</span></p>
                        
                     </div>

                    </div>
            ))
            }

        </div>
        
           <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"50%",overflowY:"auto",overflowX:"hidden",scrollbarWidth: "none", msOverflowStyle: "none",}}>
            {
            list2.map((item)=>(
                <div style={{width:"20vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px",position:"relative"
                }}>
                    <p style={{padding:"10px",borderRadius:"5px",backgroundColor:"#042b64ff",color:"white",fontSize:"14px",cursor:"pointer",
                        position:"absolute",right:"30px"
                    }}>
                        Accept</p>
                    <img src='/Assets/diagonasitic.jpg' style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                        <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item.name}</p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#d65d3eff"}}>Patients:{item.Patients}+</span>
                            <span style={{fontSize:'14px',fontWeight:"700",color:"#6fa0d8ff"}}>reg:{item.Registered}</span></p>
                        <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                            <span style={{fontSize:'16px',fontWeight:"700",color:"#a3343aff"}}>{item.Address}</span></p>
                           
                        <p style={{fontSize:"14px",fontWeight:"800"}}>Medical Test provided</p>
                        <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item.TestProvided.map(i=>
                            <p style={{fontSize:"12px",padding:"3px",borderRadius:"8px",backgroundColor:"#041c3bff",color:"white"}}>{i}</p>)
                        }</div>
                            <p style={{fontSize:"14px",fontWeight:"800"}}>Assigned Hospital</p>
                         <div style={{width:"100%",display:"flex",alignItems:"center",gap:"10px",flexWrap:"wrap"}}>
                            
                            {
                            item.Hospitals.map(i=>
                            <p style={{fontSize:"12px",padding:"3px",borderRadius:"8px",backgroundColor:"#053d2cff",color:"#fcfcfcff"}}>{i}</p>)
                        }</div>
                     </div>

                    </div>
            ))
            }

        </div>

            </div>
      </section>
    </div>
  )
}

export default Request
